<template>
  <v-app>
    <main-app-bar></main-app-bar>
    <v-main class="hk-app-bg" :style="{ backgroundImage: 'url(' + baseImg + ')' }">
      <section class="hk-section">
        <div class="hk-wrap">

          <!-- KATEGÓRIÁK -->
          <template v-if="state === 'CATEGORY'">
            <h1 class="hk-heading hk-heading--accent mb-3">Galéria</h1>
            <p class="hk-lead text-center mb-10">Válassz kategóriát munkáink megtekintéséhez</p>

            <v-row>
              <v-col v-for="(item, index) in galleryItems" :key="index" cols="12" sm="6" lg="3">
                <v-card
                    class="hk-card hk-card--hover gallery-card"
                    @click="onGalleryItemClick(item.title, item.categoryFolderName, item.pictureCount)"
                >
                  <div class="gallery-thumb">
                    <img :src="item.img" class="gallery-thumb__img" :alt="item.title" />
                    <div class="gallery-thumb__overlay">
                      <v-icon icon="mdi-magnify-plus-outline" size="34" color="white"></v-icon>
                    </div>
                  </div>
                  <div class="gallery-card__title">{{ item.title }}</div>
                </v-card>
              </v-col>
            </v-row>
          </template>

          <!-- KÉPEK -->
          <template v-if="state === 'PICTURES'">
            <div class="d-flex align-center flex-wrap ga-3 mb-8">
              <v-btn prepend-icon="mdi-arrow-left" variant="text" color="primary" @click="onBackClick">
                Vissza a galériához
              </v-btn>
              <h1 class="font-display gallery-category-title">{{ selectedCategory }}</h1>
            </div>

            <v-row>
              <v-col v-for="(picture, index) in selectedPictures" :key="index" cols="6" sm="4" lg="3">
                <v-card
                    class="hk-card hk-card--hover gallery-card"
                    @click="onPictureItemClick(picture, index)"
                >
                  <div class="gallery-thumb gallery-thumb--square">
                    <img :src="picture" class="gallery-thumb__img" alt="Hímzett munka" />
                    <div class="gallery-thumb__overlay">
                      <v-icon icon="mdi-magnify-plus-outline" size="30" color="white"></v-icon>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </template>

        </div>
      </section>

      <!-- LIGHTBOX -->
      <v-dialog v-model="pictureDialog" max-width="1100" class="lightbox">
        <div class="lightbox__bar">
          <v-btn icon="mdi-close" variant="text" color="white" @click="pictureDialog = false"></v-btn>
        </div>
        <v-carousel
            v-model="selectedSlide"
            hide-delimiters
            show-arrows="hover"
            height="80vh"
            class="lightbox__carousel"
        >
          <v-carousel-item
              v-for="(item, i) in selectedPictures"
              :key="i"
              :src="item"
              cover
              reverse-transition="fade-transition"
              transition="fade-transition"
          ></v-carousel-item>
        </v-carousel>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";
import {getAxios} from "@/AxoisFactory"

@Options({
  components: {MainAppBar},
  data() {
    return {
      state: "CATEGORY",
      selectedPictures: [],
      selectedCategory: "Kategóriák",
      baseImg: require("@/assets/base.png"),
      pictureDialog: false,
      selectedSlide: 0,
      galleryItems: [
        {
          title: "Céges ruházat",
          img: require("@/assets/jacket.png"),
          categoryFolderName: "workclothes",
          pictureCount: 10
        },
      ]
    };
  },
  created() {
    const axios = getAxios();
    axios.get("/gallery/categories").then((r: any) => {
      this.galleryItems = r.data
    })
  },
  computed: {
    getPictureCategories() {
      return this.$store.getters.getPictureCategories
    }
  },
  watch: {
    getPictureCategories(categories) {
      this.galleryItems = categories;
    }
  },
  methods: {
    onGalleryItemClick(title: string, preFix: string, count: number) {
      this.selectedCategory = title;
      this.selectedPictures = [];
      for (let i = 0; i < count; i++) {
        this.selectedPictures.push(`./gallery/${preFix}/picture/${i}`)
      }
      this.state = "PICTURES";
      window.scrollTo({top: 0, behavior: "smooth"});
    },
    onPictureItemClick(picture: string, selectedPicture: number) {
      this.selectedSlide = selectedPicture;
      this.pictureDialog = true;
    },
    onBackClick() {
      this.state = "CATEGORY";
    }
  }
})
export default class Galery extends Vue {
}
</script>

<style scoped>
.gallery-card {
  overflow: hidden;
  cursor: pointer;
}

.gallery-thumb {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
}

.gallery-thumb--square {
  aspect-ratio: 1 / 1;
}

.gallery-thumb__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.4s ease;
}

.gallery-card:hover .gallery-thumb__img {
  transform: scale(1.07);
}

.gallery-thumb__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(51, 41, 31, 0.35);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gallery-card:hover .gallery-thumb__overlay {
  opacity: 1;
}

.gallery-card__title {
  font-family: 'Playfair Display', Georgia, serif;
  font-weight: 700;
  font-size: 1.2rem;
  text-align: center;
  padding: 0.9rem 0.75rem;
  color: var(--hk-ink);
}

.gallery-category-title {
  font-size: clamp(1.5rem, 3vw, 2.2rem);
  font-weight: 700;
  color: var(--hk-secondary);
  margin: 0;
}

/* Lightbox */
.lightbox__bar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.25rem;
}

.lightbox__carousel {
  border-radius: var(--hk-radius-lg);
  overflow: hidden;
  box-shadow: var(--hk-shadow-lg);
}
</style>
